import { Controller } from 'stimulus'

export default class TooltipController extends Controller {
  connect() {
    $(this.element).tooltip({ html: true })
  }
}
